import { DRAGGABLE_TYPES } from "Common/componentUtils/constants";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import React, { useEffect, useMemo } from "react";
import { SidebarMenuList } from "../../Common";
import buildDocumentObjectSidebarItems from "../utils/buildDocumentObjectSidebarItems";
import locale from "./tabObjects.locale";
export default function TabObjects(props) {
    useEffect(() => {
        var _a;
        (_a = props.onInitialized) === null || _a === void 0 ? void 0 : _a.call(props);
    }, [props.onInitialized]);
    const sidebarMenuItems = useMemo(() => {
        if (!props.activeDocumentId || props.documentType !== DOCUMENT_TYPE.GRAPH)
            return [];
        return props.documentObjects
            ? buildDocumentObjectSidebarItems(props.documentObjects, DRAGGABLE_TYPES.DOCUMENT_OBJECT, props.readOnlyMode)
            : undefined;
    }, [props.documentObjects, props.activeDocumentId, props.documentType, props.readOnlyMode]);
    return (React.createElement(SidebarMenuList, { bgColorDefault: props.bgColorDefault, bgColorActive: props.bgColorActive, inProgress: props.inProgress, sidebarMenuItems: sidebarMenuItems, emptyText: !props.activeDocumentId || props.documentType !== DOCUMENT_TYPE.GRAPH
            ? locale.SELECT_DOCUMENT
            : "", filterText: props.filterText, sortBy: props.sortBy, sortOrder: props.sortOrder }));
}
